module.exports = __webpack_public_path__ + "img/lead_slide7_lg.8fa13d6f.png";